import { PaymentMethodService } from '@/enums/paymentMethodServices'

import { AmericanExpress } from '@/shared/icons/AmericanExpress'
import { Amex } from '@/shared/icons/Amex'
import { AmexWhite } from '@/shared/icons/AmexWhite'
import { ApplePay2 } from '@/shared/icons/ApplePay2'
import { DiscoverBW } from '@/shared/icons/DiscoverBW'
import { DiscoverWhite } from '@/shared/icons/DiscoverWhite'
import { GooglePay2 } from '@/shared/icons/GooglePay2'
import { Maestro } from '@/shared/icons/Maestro'
import { MaestroBW } from '@/shared/icons/MaestroBW'
import { MasterCard } from '@/shared/icons/MasterCard'
import { MasterCardBW } from '@/shared/icons/MasterCardBW'
import { PayPal } from '@/shared/icons/PayPal'
import { VisaBW } from '@/shared/icons/VisaBW'
import { VisaWhite } from '@/shared/icons/VisaWhite'

const defaultOrder: PaymentMethodService[] = [
  PaymentMethodService.VISA,
  PaymentMethodService.MASTERCARD,
  PaymentMethodService.AMERICAN_EXPRESS,
  PaymentMethodService.DISCOVER,
]

type PaymentMethodIconsProps = {
  order?: PaymentMethodService[]
}

export const PaymentMethodIcons = ({ order = defaultOrder }: PaymentMethodIconsProps) => {
  if (order.length == 0) {
    return null
  }

  return (
    <div className="payment-method-icons">
      {order.map((paymentService) => {
        switch (paymentService) {
          case PaymentMethodService.VISA:
            return (
              <div
                key={PaymentMethodService.VISA}
                className={'icon-container ' + PaymentMethodService.VISA}
              >
                <VisaWhite />
              </div>
            )
          case PaymentMethodService.VISA_BW:
            return (
              <div
                key={PaymentMethodService.VISA_BW}
                className={'icon-container ' + PaymentMethodService.VISA_BW}
              >
                <VisaBW />
              </div>
            )
          case PaymentMethodService.MASTERCARD:
            return (
              <div
                key={PaymentMethodService.MASTERCARD}
                className={'icon-container ' + PaymentMethodService.MASTERCARD}
              >
                <MasterCard />
              </div>
            )
          case PaymentMethodService.MASTERCARD_BW:
            return (
              <div
                key={PaymentMethodService.MASTERCARD_BW}
                className={'icon-container ' + PaymentMethodService.MASTERCARD_BW}
              >
                <MasterCardBW />
              </div>
            )
          case PaymentMethodService.MAESTRO:
            return (
              <div
                key={PaymentMethodService.MAESTRO}
                className={'icon-container ' + PaymentMethodService.MAESTRO}
              >
                <Maestro />
              </div>
            )
          case PaymentMethodService.MAESTRO_BW:
            return (
              <div
                key={PaymentMethodService.MAESTRO_BW}
                className={'icon-container ' + PaymentMethodService.MAESTRO_BW}
              >
                <MaestroBW />
              </div>
            )
          case PaymentMethodService.AMEX:
            return (
              <div
                key={PaymentMethodService.AMEX}
                className={'icon-container ' + PaymentMethodService.AMEX}
              >
                <AmexWhite />
              </div>
            )
          case PaymentMethodService.AMEX_TRANSPARENT:
            return (
              <div
                key={PaymentMethodService.AMEX}
                className={'icon-container ' + PaymentMethodService.AMEX}
              >
                <Amex />
              </div>
            )
          case PaymentMethodService.AMERICAN_EXPRESS:
            return (
              <div
                key={PaymentMethodService.AMERICAN_EXPRESS}
                className={'icon-container ' + PaymentMethodService.AMERICAN_EXPRESS}
              >
                <AmericanExpress />
              </div>
            )
          case PaymentMethodService.DISCOVER:
            return (
              <div
                key={PaymentMethodService.DISCOVER}
                className={'icon-container ' + PaymentMethodService.DISCOVER}
              >
                <DiscoverWhite />
              </div>
            )
          case PaymentMethodService.DISCOVER_BW:
            return (
              <div
                key={PaymentMethodService.DISCOVER_BW}
                className={'icon-container ' + PaymentMethodService.DISCOVER_BW}
              >
                <DiscoverBW />
              </div>
            )
          case PaymentMethodService.PAYPAL:
            return (
              <div
                key={PaymentMethodService.PAYPAL}
                className={'icon-container ' + PaymentMethodService.PAYPAL}
              >
                <PayPal />
              </div>
            )
          case PaymentMethodService.APPLE_PAY:
            return (
              <div
                key={PaymentMethodService.APPLE_PAY}
                className={'icon-container ' + PaymentMethodService.APPLE_PAY}
              >
                <ApplePay2 />
              </div>
            )
          case PaymentMethodService.GOOGLE_PAY:
            return (
              <div
                key={PaymentMethodService.GOOGLE_PAY}
                className={'icon-container ' + PaymentMethodService.GOOGLE_PAY}
              >
                <GooglePay2 />
              </div>
            )
        }
      })}
    </div>
  )
}
